import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { ImportDeclarationService } from './../../services/import-declaration.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-import-header-detail',
  templateUrl: './import-header-detail.component.html',
  styleUrls: ['./import-header-detail.component.scss']
})
export class ImportHeaderDetailComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: string;
  importHeader: any;
  forwarderOptions: any[];
  billObjectTypeOptions: any[];
  billObjectOptions: any[];
  orgIdOptions: any[];
  billCorpOptions: any[];
  incoTermOptions: any[];
  vendorOptions: any[];
  importTypeOptions: any[];
  docTypeOptions: any[];
  currencyOptions: any[];
  countryOptions: any[];
  cityOptions: any[];
  isShowEditBtn: boolean;
  isShowConfirmBtn: boolean;
  isShowCancelBtn: boolean;

  constructor(
    injector: Injector,
    private importDeclarationService: ImportDeclarationService,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService
  ) {
    super(injector);
    this.permissionCode = PermissionConstants.ViewImportDeclaration;
    this.importHeader =  {};
    this.forwarderOptions = [];
    this.billObjectTypeOptions = [];
    this.billObjectOptions = [];
    this.orgIdOptions = [];
    this.billCorpOptions = [];
    this.incoTermOptions = [];
    this.vendorOptions = [];
    this.importTypeOptions = [];
    this.docTypeOptions = [];
    this.currencyOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.isShowEditBtn = false;
    this.isShowConfirmBtn = false;
    this.isShowCancelBtn = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    const importDeclarationNo = this.routeStateService.getCurrent().data.importDeclarationNo;

    try{
      this.importHeader = await this.importDeclarationService.getImportHeaderDetail(importDeclarationNo);
      this.importHeader.estimatedGvAcctdAmount = this.getAmountString(this.importHeader.gvAcctdAmount, this.importHeader.estimatedGvAcctdAmount);
      this.importHeader.estimatedGvAcctdAmountTax = this.getAmountString(this.importHeader.gvAcctdAmountTax, this.importHeader.estimatedGvAcctdAmountTax);
      this.importHeader.estimatedGvAcctdExpBAmount = this.getAmountString(this.importHeader.gvAcctdExpBAmount, this.importHeader.estimatedGvAcctdExpBAmount);
      this.importHeader.estimatedGvAcctdExpCAmount = this.getAmountString(this.importHeader.gvAcctdExpCAmount, this.importHeader.estimatedGvAcctdExpCAmount);
      this.importHeader.estimatedGvAcctdExpDAmount = this.getAmountString(this.importHeader.gvAcctdExpDAmount, this.importHeader.estimatedGvAcctdExpDAmount);
    }catch (err: any) {
      console.log('get import header occur error: ' + JSON.stringify(err));
    }

    this.facilityService.getForwarderOptions(this.importHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectOptions(this.importHeader.facility, this.importHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.importHeader.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityReferenceCode}-${x.legalEntityOUName}(${x.legalEntityOUCode})`,
            value: x.legalEntityOUCode,
          };
        });
        this.billCorpOptions = [...result].map((x: any) => {
          return {
            label: `${x.billReferenceCode}-${x.billOUName}(${x.billOUCode})`,
            value: x.billOUCode,
          };
        });
      }
    });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.incoTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getVendorOptions(this.importHeader.vendor).subscribe({
      next: result => {
        this.vendorOptions = [...result].map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getImportTypeOptions().subscribe({
      next: result => {
        this.importTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getImportDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityOptions = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
          };
        });
      }
    });

    this.isShowEditBtn = this.importHeader.status === 'A';
    this.isShowConfirmBtn = this.importHeader.status === 'A';
    this.isShowCancelBtn = this.importHeader.status === 'B';

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }
  }

  goToEdit(event: any): void{
    this.routeStateService.navigateTo('/TransportOperation/ImportHeaderEdit', this.importHeader);
  }

  getAmountString(actualAmount: any, estimatedAmount: any): string {
    actualAmount = actualAmount !== null ? Number.parseFloat(actualAmount).toFixed(2) : null;
    estimatedAmount = estimatedAmount !== null ? Number.parseFloat(estimatedAmount).toFixed(2) : null;
    let amount = actualAmount;

    if (!isNullOrEmpty(actualAmount) && !isNullOrEmpty(estimatedAmount)) {
      amount = `${actualAmount}(${estimatedAmount})`;
    }

    if (isNullOrEmpty(amount)) {
      return estimatedAmount;
    }

    return amount
  }

  confirmBtnClick(event: any): any {
    this.loader.show();

    var confirmParam = {
      importDeclarationNo: this.importHeader.importDeclarationNo
    };

    this.importDeclarationService.confirmImportDeclaration(confirmParam).subscribe({
      next: result => {
        if (result.flag == "S") {
          this.toastService.success(this.translateService.instant('ImportDeclareSearch.Success.ConfirmSuccess'));
          this.importHeader.status = "B";
        } else {
          this.toastService.error(result.message);
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }

  cancelBtnClick(event: any): any {
    this.loader.show();

    const cancelParam = {
      importDeclarationNo: this.importHeader.importDeclarationNo
    };

    this.importDeclarationService.cancelImportDeclaration(cancelParam).subscribe({
      next: result => {
        if (result.qfunction_com.length > 0) {
          var erpResult = result.qfunction_com[0].l_out;
          if (erpResult === "0") {
            this.toastService.success(this.translateService.instant('ImportDeclareSearch.Success.CancelSuccess'));
            this.importHeader.status = "A";
          } else if (erpResult === "1") {
            this.toastService.error(this.translateService.instant('ImportDeclareSearch.Alert.ImportDeclarationPaid'));
          }
        } else {
          this.toastService.error(this.translateService.instant('ImportDeclareSearch.Alert.ERPReturnedError'));
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      },
      complete: () => {
        this.loader.hide();
      }
    })
  }
}
